var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeleteBinFill = function SvgDeleteBinFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.5 6.6H21v1.8h-1.8v11.7a.9.9 0 0 1-.9.9H5.7a.9.9 0 0 1-.9-.9V8.4H3V6.6h4.5V3.9a.9.9 0 0 1 .9-.9h7.2a.9.9 0 0 1 .9.9zm-7.2 4.5v5.4h1.8v-5.4zm3.6 0v5.4h1.8v-5.4zM9.3 4.8v1.8h5.4V4.8z"
  })));
};
export default SvgDeleteBinFill;